<div [class]="wrapperClass + ' text-start pdropdownwrapper'">
  @if (label && label.length) {
    <label (click)="control.enabled && openDropdown($event);" [for]="id + '_input'">
      {{ label }}
      @if ((controlIsRequired$ | async) && showRequiredStar) {
        <em class="text-danger">*</em>
      }
    </label>
  }
  <p-select #dropdown
            [autofocus]="false"
            (onBlur)="onBlur.emit($event)"
            (onChange)="onSelect.emit($event)"
            (onHide)="currentDropdownIcon = dropdownIcon"
            (onShow)="currentDropdownIcon = dropdownIconWhenOpened"
            [appendTo]="appendTo"
            [class.disabled]="control.disabled"
            [class.readonly]="readonly"
            [class]="inputClass"
            [dropdownIcon]="currentDropdownIcon"
            [editable]="editable"
            [filter]="minItemsForFilter !== false  && itemsForTemplate.length >= minItemsForFilter"
            [formControl]="control"
            [inputId]="id + '_input'"
            [options]="itemsForTemplate"
            [placeholder]="placeholder ?? ''"
            [readonly]="readonly">
    <!--<option *ngIf="includePleaseSelect" [value]="null" disabled>{{'label.dropdownitem.pleaseSelect'}}</option>
    <ng-container *ngIf="!translateItems">
      <option *ngFor="let o of items" [disabled]="o.disabled" [ngValue]="o.value">{{o.label}}</option>
    </ng-container>
    <ng-container *ngIf="translateItems">
      <option *ngFor="let o of items" [disabled]="o.disabled" [ngValue]="o.value">{{o.label}}</option>
    </ng-container>-->
  </p-select>
  <input-error-output [control]="control"></input-error-output>
</div>
